<div class="p-2 flex place-content-center text-xl font-bold">{{ drawTable.title }}</div>
<table class="table-auto border-collapse border-2 border-black w-full" style="overflow-wrap: anywhere;">
  @if (drawTable.dn?.length > 0) {
    <thead class="border-2 border-black">
      <tr [ngClass]="{'bg-green-300 dark:bg-green-800': drawTable.status === 'LIVE', 'bg-orange-300 dark:bg-orange-800': drawTable.status === 'DESIGN', 'bg-gray-300 dark:bg-gray-800': drawTable.status === 'BEST_COMPATIBLE'}">
        <th class="p-2 w-2/5">
          <span class="flex">{{ 'dbTables.node' | transloco }}</span>
        </th>
        <ng-container *ngTemplateOutlet="headerIcons"></ng-container>
      </tr>
    </thead>
    @for (item of drawTable.dn; track item) {
      <tbody>
        <tr [ngClass]="{'bg-red-200 dark:bg-red-800': item.isDifferent && !item.onlyHere, 'bg-blue-200 dark:bg-blue-800': item.onlyHere && !item.isDifferent , 'bg-amber-200 dark:bg-amber-800': item.onlyHere && item.isDifferent}">
          <td class="border border-black p-2">{{ item.name }}</td>
          <td class="border border-black p-2">{{ item.value }}</td>
        </tr>
      </tbody>
    }
  }

  <thead class="border-2 border-black">
    <tr [ngClass]="{'bg-green-300 dark:bg-green-800': drawTable.status === 'LIVE', 'bg-orange-300 dark:bg-orange-800': drawTable.status === 'DESIGN', 'bg-gray-300 dark:bg-gray-800': drawTable.status === 'BEST_COMPATIBLE'}">
      <th class="p-2 w-2/5">
        <span class="flex">{{ 'dbTables.table' | transloco }}</span>
      </th>
      <ng-container *ngTemplateOutlet="headerIcons"></ng-container>
    </tr>
  </thead>
  <tbody>
    @if (drawTable.tableType) {
      <tr [ngClass]="{'bg-red-200 dark:bg-red-800': drawTable.tableType.isDifferent && !drawTable.tableType.onlyHere, 'bg-blue-200 dark:bg-blue-800': drawTable.tableType.onlyHere && !drawTable.tableType.isDifferent , 'bg-amber-200 dark:bg-amber-800': drawTable.tableType.onlyHere && drawTable.tableType.isDifferent}">
        <td class="border border-black p-2">{{ $safeNavigationMigration(drawTable.tableType?.name) | transloco }}</td>
        <td class="border border-black p-2">{{ drawTable.tableType.value }}</td>
      </tr>
    }
    @if (drawTable.elementType) {
      <tr [ngClass]="{'bg-red-200 dark:bg-red-800': drawTable.elementType.isDifferent && !drawTable.elementType.onlyHere, 'bg-blue-200 dark:bg-blue-800': drawTable.elementType.onlyHere && !drawTable.elementType.isDifferent , 'bg-amber-200 dark:bg-amber-800': drawTable.elementType.onlyHere && drawTable.elementType.isDifferent}">
        <td class="border border-black p-2">{{ $safeNavigationMigration(drawTable.elementType?.name) | transloco }}</td>
        <td class="border border-black p-2">
          <div class="flex items-center justify-between" cdkOverlayOrigin #triggerFromET="cdkOverlayOrigin">
            <span>{{ drawTable.elementType.value }}</span>
            @if (drawTable.elementType?.tooltipItem) {
              <mat-icon (click)="drawTable.elementType.tooltipItem.show = !drawTable.elementType.tooltipItem.show"
              [svgIcon]="'heroicons_solid:information-circle'"></mat-icon>
            }
            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="triggerFromET"
              [cdkConnectedOverlayOpen]="$safeNavigationMigration(drawTable.elementType?.tooltipItem?.show)" [cdkConnectedOverlayHasBackdrop]="true"
              [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
              (backdropClick)="drawTable.elementType.tooltipItem.show = !drawTable.elementType.tooltipItem.show">
              <ng-container *ngTemplateOutlet="uriTooltip; context: { $implicit: $safeNavigationMigration(drawTable.elementType?.tooltipItem) }"></ng-container>
            </ng-template>
          </div>
        </td>
      </tr>
    }
    <tr [ngClass]="{'bg-red-200 dark:bg-red-800': drawTable.tableName.isDifferent && !drawTable.tableName.onlyHere, 'bg-blue-200 dark:bg-blue-800': drawTable.tableName.onlyHere && !drawTable.tableName.isDifferent , 'bg-amber-200 dark:bg-amber-800': drawTable.tableName.onlyHere && drawTable.tableName.isDifferent}">
      <td class="border border-black p-2">{{ $safeNavigationMigration(drawTable.tableName?.name) | transloco }}</td>
      <td class="border border-black p-2">
        <div class="flex items-center justify-between">
          <span>{{ drawTable.tableName?.value }}</span>
          @if (drawTable.tableName?.tooltipItem?.show) {
            <mat-icon [cdkCopyToClipboard]="$safeNavigationMigration(drawTable.tableName?.value)" [svgIcon]="'mat_outline:content_copy'"
            (click)="copyToClipboard()"></mat-icon>
          }
        </div>
      </td>
    </tr>
    @if (drawTable.tableSchema) {
      <tr [ngClass]="{'bg-red-200 dark:bg-red-800': drawTable.tableSchema.isDifferent && !drawTable.tableSchema.onlyHere, 'bg-blue-200 dark:bg-blue-800': drawTable.tableSchema.onlyHere && !drawTable.tableSchema.isDifferent , 'bg-amber-200 dark:bg-amber-800': drawTable.tableSchema.onlyHere && drawTable.tableSchema.isDifferent}">
        <td class="border border-black p-2">{{ $safeNavigationMigration(drawTable.tableSchema?.name) | transloco}}</td>
        <td class="border border-black p-2">{{ drawTable.tableSchema?.value }}</td>
      </tr>
    }
    @if (drawTable.uriName) {
      <tr [ngClass]="{'bg-red-200 dark:bg-red-800': drawTable.uriName.isDifferent && !drawTable.uriName.onlyHere, 'bg-blue-200 dark:bg-blue-800': drawTable.uriName.onlyHere && !drawTable.uriName.isDifferent , 'bg-amber-200 dark:bg-amber-800': drawTable.uriName.onlyHere && drawTable.uriName.isDifferent}">
        <td class="border border-black p-2">{{ $safeNavigationMigration(drawTable.uriName?.name) | transloco }}</td>
        <td class="border border-black p-2">
          <div class="flex items-center justify-between" cdkOverlayOrigin #triggerFromUN="cdkOverlayOrigin">
            <span>{{ drawTable.uriName?.value }}</span>
            @if (drawTable.uriName?.tooltipItem) {
              <mat-icon (click)="drawTable.uriName.tooltipItem.show = !drawTable.uriName.tooltipItem.show"
              [svgIcon]="'heroicons_solid:information-circle'"></mat-icon>
            }
            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="triggerFromUN"
              [cdkConnectedOverlayOpen]="$safeNavigationMigration(drawTable.uriName?.tooltipItem?.show)" [cdkConnectedOverlayHasBackdrop]="true"
              [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
              (backdropClick)="drawTable.uriName.tooltipItem.show = !drawTable.uriName.tooltipItem.show">
              <ng-container *ngTemplateOutlet="uriTooltip; context: { $implicit: $safeNavigationMigration(drawTable.uriName?.tooltipItem) }"></ng-container>
            </ng-template>
          </div>
        </td>
      </tr>
    }
    @if (drawTable.linkField) {
      <tr [ngClass]="{'bg-red-200 dark:bg-red-800': drawTable.linkField.isDifferent && !drawTable.linkField.onlyHere, 'bg-blue-200 dark:bg-blue-800': drawTable.linkField.onlyHere && !drawTable.linkField.isDifferent , 'bg-amber-200 dark:bg-amber-800': drawTable.linkField.onlyHere && drawTable.linkField.isDifferent}">
        <td class="border border-black p-2">{{ $safeNavigationMigration(drawTable.linkField?.name) | transloco }}</td>
        <td class="border border-black p-2">{{ drawTable.linkField?.value }}</td>
      </tr>
    }
    @if (drawTable.linkType) {
      <tr [ngClass]="{'bg-red-200 dark:bg-red-800': drawTable.linkType.isDifferent && !drawTable.linkType.onlyHere, 'bg-blue-200 dark:bg-blue-800': drawTable.linkType.onlyHere && !drawTable.linkType.isDifferent , 'bg-amber-200 dark:bg-amber-800': drawTable.linkType.onlyHere && drawTable.linkType.isDifferent}">
        <td class="border border-black p-2">{{ $safeNavigationMigration(drawTable.linkType?.name) | transloco }}</td>
        <td class="border border-black p-2">
          <div class="flex items-center justify-between" cdkOverlayOrigin #triggerFromLT="cdkOverlayOrigin">
            <span>{{ drawTable.linkType?.value }}</span>
            @if (drawTable.linkType?.tooltipItem) {
              <mat-icon (click)="drawTable.linkType.tooltipItem.show = !drawTable.linkType.tooltipItem.show"
              [svgIcon]="'heroicons_solid:information-circle'"></mat-icon>
            }
            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="triggerFromLT"
              [cdkConnectedOverlayOpen]="$safeNavigationMigration(drawTable.linkType?.tooltipItem?.show)" [cdkConnectedOverlayHasBackdrop]="true"
              [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
              (backdropClick)="drawTable.linkType.tooltipItem.show = !drawTable.linkType.tooltipItem.show">
              <ng-container *ngTemplateOutlet="uriTooltip; context: { $implicit: $safeNavigationMigration(drawTable.linkType?.tooltipItem) }"></ng-container>
            </ng-template>
          </div>
        </td>
      </tr>
    }
  </tbody>

  @if (drawTable.columns?.length > 0) {
    <thead class="border-2 border-black">
      <tr [ngClass]="{'bg-green-300 dark:bg-green-800': drawTable.status === 'LIVE', 'bg-orange-300 dark:bg-orange-800': drawTable.status === 'DESIGN', 'bg-gray-300 dark:bg-gray-800': drawTable.status === 'BEST_COMPATIBLE'}">
        <th class="p-2 w-2/5">
          <span class="flex">{{ 'dbTables.fields' | transloco }}</span>
        </th>
        <ng-container *ngTemplateOutlet="headerIcons"></ng-container>
      </tr>
    </thead>
    @for (item of drawTable.columns; track item) {
      <tbody>
        <tr [ngClass]="{'bg-red-200 dark:bg-red-800': item.isDifferent && !item.onlyHere, 'bg-blue-200 dark:bg-blue-800': item.onlyHere && !item.isDifferent , 'bg-amber-200 dark:bg-amber-800': item.onlyHere && item.isDifferent}">
          <td class="border border-black p-2">{{ item.name }}</td>
          <td class="border border-black p-2">
            <div class="flex items-center justify-between">
              <span>{{ item.value }}</span>
              <mat-icon [matTooltip]="item.tooltipItem.tooltip" matTooltipClass="columnsTooltip" [svgIcon]="'heroicons_solid:information-circle'"></mat-icon>
            </div>
          </td>
        </tr>
      </tbody>
    }
  }
  @if (drawTable.indexes?.length > 0) {
    <thead class="border-2 border-black">
      <tr [ngClass]="{'bg-green-300 dark:bg-green-800': drawTable.status === 'LIVE', 'bg-orange-300 dark:bg-orange-800': drawTable.status === 'DESIGN', 'bg-gray-300 dark:bg-gray-800': drawTable.status === 'BEST_COMPATIBLE'}">
        <th class="p-2 w-2/5">
          <span class="flex">{{ 'dbTables.indexes' | transloco }}</span>
        </th>
        <ng-container *ngTemplateOutlet="headerIcons"></ng-container>
      </tr>
    </thead>
    @for (item of drawTable.indexes; track item) {
      <tbody>
        <tr [ngClass]="{'bg-red-200 dark:bg-red-800': item.isDifferent && !item.onlyHere, 'bg-blue-200 dark:bg-blue-800': item.onlyHere && !item.isDifferent , 'bg-amber-200 dark:bg-amber-800': item.onlyHere && item.isDifferent}">
          <td class="border border-black p-2"> {{ item.name }}</td>
          <td class="border border-black p-2">{{ item.value }}</td>
        </tr>
      </tbody>
    }
  }
</table>

<ng-template #uriTooltip let-item>
  <div class="flex flex-row items-center border rounded bg-black text-white" (mouseleave)="item.show = !item.show">
    <b class="pl-2">{{ item.tooltip }}</b>
    <button mat-icon-button [cdkCopyToClipboard]="item.tooltip" (click)="toggleAndCopy($event, item)">
      <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:content_copy'"></mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #headerIcons>
  <th class="p-2 flex justify-end">
    @if (drawTable.status === 'LIVE') {
      <mat-icon class="flex justify-end" [svgIcon]="'feather:heart'" matTooltip="{{'dbTables.live' | transloco}}"></mat-icon>
    }
    @if (drawTable.status === 'DESIGN') {
      <mat-icon class="flex justify-end" [svgIcon]="'mat_outline:draw'" matTooltip="{{'dbTables.design' | transloco}}"></mat-icon>
    }
    @if (drawTable.status === 'BEST_COMPATIBLE') {
      <mat-icon class="flex justify-end" [svgIcon]="'mat_outline:lightbulb'" matTooltip="{{'dbTables.bestCompatible' | transloco}}"></mat-icon>
    }
  </th>
</ng-template>